import { signOut, getAuth } from "firebase/auth";
import "./Home.css";
import { Context } from "../../components/Context/AuthContext";
import { useContext } from "react";
import { Link, Outlet } from "react-router-dom";
import { NavigationItem } from "../../components/Home/NavigationItem";
import { useUserRole } from "../../components/Context/useUserRole";

export function Home() {
  const auth = getAuth();
  const { user } = useContext(Context);
  const role = useUserRole();

  const roleImages = {
    "Инженер": "./img/engineer-dark.svg",
    "Диспетчер": "./img/dispatcher-dark.svg",
    "Директор": "./img/boss.svg",
  };

  async function handleLogout() {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Error signing out:", error);
    }
  }

  return (
    <div className="flex">
      <aside>
        <nav>
        {navigationItems.map((item) => (
            <NavigationItem
              key={item.path}
              {...item}
              user={user}
              userRole={role}
            />
          ))}
        </nav>
        <div className="nav">
          <ul>
            <li id="aside-circle" className="aside-row">
              <Link className="profile-icons__link" to="/profile">
                <div className="profile-icons">
                  <img src={roleImages[role]} alt="Account" />
                </div>
              </Link>
              <div className="tooltip-aside">{user.email}</div>
            </li>
            <li className="aside-row">
              <button onClick={handleLogout}>
                <img src="./img/exit-aside.svg" alt="Exit" />
              </button>
              <div className="tooltip-aside">Выход</div>
            </li>
          </ul>
        </div>
      </aside>
      <main className="container">
        <Outlet />
      </main>
    </div>
  );
}

const navigationItems = [
  {
    path: "/addRequest",
    icon: "./img/plus-aside.svg",
    alt: "Add request",
    tooltip: "Добавить",
    roles: ["Диспетчер", "Директор"],
  },
  {
    path: "/search",
    icon: "./img/search-aside.svg",
    alt: "Search",
    tooltip: "Поиск",
    roles: ["Инженер", "Диспетчер", "Директор"],
  },
  {
    path: "/openedRequest",
    icon: "./img/request-check-aside.svg",
    alt: "Request check",
    tooltip: "Открытые заявки",
    roles: ["Инженер", "Диспетчер", "Директор"],
  },
  {
    path: "/closedRequest",
    icon: "./img/request-opened-aside.svg",
    alt: "Request opened",
    tooltip: "Завершенные заявки",
    roles: ["Инженер", "Диспетчер", "Директор"],
  },
  {
    path: "/engineers",
    icon: "./img/engineer-aside.svg",
    alt: "Engineers",
    tooltip: "Инженеры",
    roles: ["Инженер", "Диспетчер", "Директор"],
  },
  {
    path: "/dispatchers",
    icon: "./img/dispatcher-aside.svg",
    alt: "Dispatcher",
    tooltip: "Диспетчеры",
    roles: ["Инженер", "Диспетчер", "Директор"],
  },
  {
    path: "/switch",
    icon: "./img/roles-switch.svg",
    alt: "switch",
    tooltip: "Смена ролей",
    roles: ["Директор"],
  },
];
